<template>
  <section
    :style="{
      'box-shadow': ' 0 16px 60px' + content.shadow,
    }"
    class="position-relative m-auto"
  >
    <div class="pt-5 img-container text-center">
      <img
        :src="
          require(`@/assets/images/create-survey/${tenantType}_${content.type}-scene.svg`)
        "
        :alt="content.alt"
        class="img-fluid"
      />
    </div>

    <div class="text-start py-4 px-4 body-container">
      <h3 class="title m-0 text-uppercase">{{ content.type }}</h3>
      <span class="description" v-html="content.description"></span>
      <p v-html="content.body" class="body-content py-5 pe-xl-5"></p>

      <div class="space"></div>

      <div
        :class="{ 'grow-up': growUp }"
        class="drop-up d-flex align-items-center d-block position-absolute"
      >
        <div
          @click="growUpToggle()"
          v-if="!growUp"
          class="
            select
            cursor-pointer
            w-100
            h-100
            d-flex
            align-items-center
            text-capitalize
          "
        >
          <span class="px-4">select</span>
        </div>

        <div
          v-if="showContent"
          class="row w-100 g-0 px-4"
          v-click-outside="closePopup"
        >
          <span
            @click="closePopup"
            class="close-btn text-end cursor-pointer position-absolute"
            >x</span
          >
          <ul class="list-unstyled col-11">
            <li
              v-for="element of content.dropUpList"
              :key="element.type"
              :class="element.class"
              class="cursor-pointer"
              @click="toggleForm(content.type, element.type)"
            >
              <div class="row g-0">
                <div class="col-md-1 col-2 p-0 d-flex align-items-center">
                  <img
                    :alt="element.type"
                    :src="
                      require(`@/assets/images/create-survey/${element.type}.svg`)
                    "
                    class="img-fluid"
                    width="25"
                  />
                </div>
                <div class="col-md-11 col-10 text-start">
                  <h5 class="m-0 p-0 text-capitalize">{{ element.header }}</h5>
                </div>
              </div>
              <div class="row g-0">
                <div class="col-1"></div>
                <div class="col-11 text-start">
                  <span>{{ element.body }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SurveyTypeCard",
  props: {
    content: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      growUp: false,
      showContent: false,
    };
  },
  computed: {
    tenantType() {
      return this.$store.getters["auth/tenantType"].toUpperCase();
    },
  },
  methods: {
    growUpToggle() {
      this.growUp = true;
      setTimeout(() => {
        this.showContent = true;
      }, 100);
    },
    toggleForm(surveyType, formType) {
      this.$store.dispatch("surveyJourney/showForm", {
        formType: formType,
        surveyType: surveyType,
      });
    },
    closePopup() {
      this.growUp = false;
      this.showContent = false;
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  width: 90%;
  @extend %background-grey-1-border-white-1;
  border-radius: $radius-44;
  min-height: 738px;
  color: $color-white;
}

.img-container {
  background-color: $color-black;
  border: $border-white-1;
  border-radius: $radius-44;
  height: 305px;
  background-image: url(../../assets/images/create-survey/stripes.svg);
  background-size: 113%;
  background-repeat: no-repeat;
  background-position: center;

  img {
    max-height: 100%;
  }
}

.title {
  @extend %font-60-79-bold;
}

.description {
  @extend %font-26_28-regular;
}

.body-content {
  @extend %font-16_18-regular;
  letter-spacing: 0;
  color: $color-grey-30;
}
.space {
  height: 78px;
}

.drop-up {
  bottom: 5%;
  left: 50%;
  transform: translate(-50%);
  min-height: 78px;
  width: 91%;
  border-radius: $radius-39;
  transition: $transition-200ms;
  @extend %background-white-color-black;

  .select {
    @extend %font-24-regular;
    min-height: 78px;
  }

  li {
    span {
      color: $color-grey-40;
      @extend %font-16_18-regular;
      transition: $transition-200ms;
    }

    &:hover {
      color: $color-black;

      span {
        color: $color-black;
      }
    }
  }
}

.close-btn {
  color: $color-grey-60;
  font-size: $font-size-24;
  top: 10px;
  right: 20px;
  width: 2.5rem;
}

.grow-up {
  height: max-content;
  min-height: 250px;
}
</style>
